<i18n>
[
    "browse__size--title",
]
</i18n>

<template>
    <UrbnModalLauncher
        :modalOptions="{
            ...sizeMenuModal,
            props: { catalogContext },
        }"
        variant="none"
        type="button"
        class="c-size-launcher o-flex-vertical-center o-flex-horizontal-center o-text--caption u-text--gray"
        :data-product-tour-lightbox="productTourLightboxes.sizesLarge.selector"
    >
        <BaseIcon
            icon="catalog--size"
            size="24px"
            color="gray"
            class="c-size-launcher__size-icon"
        />
        {{ $t('browse__size--title') }}
        <span v-if="selectedSizeList" class="c-size-launcher__label o-text--caption">
            {{ selectedSizeList }}
        </span>
    </UrbnModalLauncher>
</template>

<script>

import { MODALS } from '~modules/modals/js/modal-constants';

import UrbnModalLauncher from '~coreModules/modals/components/UrbnModalLauncher.vue';
import { CATALOG_TOUR_LIGHTBOXES } from '~modules/product-tour/js/product-tour-constants';

export default {
    name: 'CatalogSizeLauncher',
    components: {
        UrbnModalLauncher,
    },
    props: {
        catalogContext: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        sizeMenuModal: MODALS.catalogSizeMenu,
        productTourLightboxes: CATALOG_TOUR_LIGHTBOXES,

    }),
    computed: {
        selectedSizeList() {
            return this.$store.getters[`${this.catalogContext}/selectedSizeList`];
        },
    },
};
</script>

<style lang="scss">

    .c-size-launcher {
        min-width: 150px;
        padding: 0 $nu-spacer-2;
        background-color: $nu-white;
        border-radius: 2px;
        height: 40px;
        border: 0;
        outline: none;
        cursor: pointer;

        &__size-icon {
            margin-right: $nu-spacer-1pt5;
            position: relative;
            top: 0;

            svg {
                margin: 0;
            }
        }

        &__label {
            color: $nu-primary;
            margin-left: $nu-spacer-1pt5;
            max-width: 85px;

            @include ellipsize;
        }
    }

</style>
